/* Selling-unit snapshots only. Does not calculate freight or change payable prices. */
(() => {
  function sync(form) {
    const scope = form.closest('product-info') || form.closest('.quick-add-modal__content');
    const area = Number(scope?.querySelector('[data-wfod-box-area]')?.dataset.wfodBoxArea || 0);
    const unit = form.querySelector('[data-wfod-unit-property]');
    const coverage = form.querySelector('[data-wfod-area-property]');
    if (!unit || !coverage) return;
    unit.disabled = !(area > 0);
    coverage.disabled = !(area > 0);
    coverage.value = area > 0 ? String(area) : '';
  }
  document.addEventListener('submit', event => {
    if (event.target.matches('form[data-type="add-to-cart-form"]')) sync(event.target);
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('product-form input[name="id"]')) sync(event.target.form);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(sync));
  }
})();
